import React, { Component, useState } from "react";
import { Navigate } from "react-router-dom";
import Server from ".././Server.js";
import { Toast } from "primereact/toast";
import { connect } from "react-redux";
import { Menu } from "antd";
import { MailOutlined } from "@ant-design/icons";

import "./RightBox.css";

class RightBox extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.Server = new Server();
    this.state = {
      list: this.props.list || [],
      data: this.props.data || [],
      isOpen: false,
      setIsOpen: true,
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(1),
      oldComponents: [],
      systems: [],
    };
    this.toast = React.createRef();

    this.logout = this.logout.bind(this);
    this.GoToForm = this.GoToForm.bind(this);
  }
  componentDidMount() {
    this.getList();

  }

  persianNumber(input) {
    var persian = {
      0: "۰",
      1: "۱",
      2: "۲",
      3: "۳",
      4: "۴",
      5: "۵",
      6: "۶",
      7: "۷",
      8: "۸",
      9: "۹",
    };
    var string = (input + "").split("");
    var count = string.length;
    var num;
    for (var i = 0; i <= count; i++) {
      num = string[i];
      if (persian[num]) {
        string[i] = persian[num];
      }
    }
    return string.join("");
  }



  getList() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      selectedSystem: this.props.selectedSystem,
    };
    let SCallBack = function (response) {
      let res = [];
      let result = response.data.result;
      let item = {}
      for (let i = 0; i < result.length; i++) {
        result[i].children = [];
        result[i].key = result[i].CId;
        for (let j = 0; j < result.length; j++) {
          result[j].icon = result[j].Icon ? <i className={result[j].Icon} /> : null;
          result[j].label = result[j].FName;
          if (result[i].CId == result[j].Parent && result[i].IsTitle) {
            result[i].children.push(result[j]);
            result[j].remove = 1;
          }
        }
      }
      for (let i = 0; i < result.length; i++) {
        delete result[i].Details;
        delete result[i].FName;
        delete result[i].IsTitle;
        delete result[i]._id;        

        if(!result[i].icon && !result[i].Parent){
          result[i].icon = <MailOutlined />

        }
        if (result[i].children.length == 0) delete result[i].children;
        if (!result[i].remove) res.push(result[i]);
      }
      that.setState({
        list: res,
        originalList: response.data.result,
      });
    };

    let ECallBack = function (error) {
      console.log(error);
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 3000,
      });
    };
    this.Server.send(
      "CompanyApi/GetComponentsList",
      param,
      SCallBack,
      ECallBack
    );
  }

  logout(e) {
    let that = this;
    let SCallBack = function (response) {
      localStorage.setItem("api_token", "");
      that.setState({
        logout: true,
      });
    };
    let ECallBack = function (error) {};
    this.Server.send("MainApi/logout", {}, SCallBack, ECallBack);
  }
  goToHome(e) {
    this.setState({
      goToHome: true,
    });
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }
  componentWillReceiveProps(props, state) {
    if (props.oldComponents)
      this.setState({
        oldComponents: props.oldComponents,
      });
  }
  GoToForm(CId, IsReport, help, label,parentLabel) {
    let current = {
      CId: CId,
      IsReport: IsReport,
      help: help,
      label,
      permitions: [],
      parentLabel: parentLabel
    };
    let oldComponents = this.state.oldComponents;
    oldComponents.push(current);
    this.setState({
      oldComponents: oldComponents,
    });
    this.props.callback({ oldComponents });
    window.scrollTo(0, 0);
  }
  render() {
    if (this.state.logout) {
      return <Navigate to={"/"} push={true} />;
    }
    if (this.state.goToHome) {
      return <Navigate to={"/"} push={true} />;
    }

    return (
      <div style={{ textAlign: "center", margin: 5 }}>
          <Toast
            ref={this.toast}
            position="top-left"
            style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
          />
            <Menu
                mode="inline"
                items={this.state.list}
                onClick={(e) => {
                  for (let item of this.state.originalList) {
                    if (item.CId == e.key && (item.IsReport || item.Url)) {
                      let parentLabel = "";
                      if(item.Parent){
                        parentLabel = this.state.originalList.filter((list)=>{ return item.Parent == list.CId})[0]?.label;
                      }

                      this.GoToForm(
                        item.CId,
                        item.IsReport,
                        item.help,
                        item.label,
                        parentLabel
                      );
                    }
                  }
                }}
              />
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(RightBox);
